import cx from 'classnames'
import * as React from 'react'

import { buildActionAnalyticsAttributes } from '@mondough/analytics-v2'
import { useCopy } from '@mondough/copy'
import { ShowForLocale } from '@mondough/locale'
import { Text, Title } from '@mondough/monzo-ui'

import { ReferralContext } from '../../../providers'
import bba from '../../../public/images/trust/bba.png'
import cass from '../../../public/images/trust/cass.svg'
import fscs from '../../../public/images/trust/fscs.svg'
import { getCDNSrc } from '../../../utils'
import { Button } from '../../'
import styles from './SingleBlockBanner.module.scss'

const SingleBlockBanner = ({
  title,
  text,
  imageSrc,
  buttonText,
  buttonHref,
}: {
  title: string
  text: string
  imageSrc: string
  buttonText: string
  buttonHref: string
}) => {
  const { referralData } = React.useContext(ReferralContext)
  const c = useCopy()

  return (
    <div className={cx([styles.inner, referralData ? '' : 'desktop-only'])}>
      <img src={getCDNSrc(imageSrc)} alt="" className={styles.illustration} />
      <Title is="h2" size="small" color="primary" className={styles['title']}>
        {title}
      </Title>
      <Text color="primary" size="large" className={styles['text']}>
        {text}
      </Text>
      <Button
        theme="secondary"
        href={buttonHref}
        className={styles.button}
        target="_blank"
        rel="noopener noreferrer"
        {...buildActionAnalyticsAttributes('claim-referral')}
      >
        {buttonText}
      </Button>
      <ShowForLocale locales={['en-GB']}>
        <ul className={cx([styles['trust-grid'], 'desktop-only'])}>
          <li>
            <img
              src={getCDNSrc(bba)}
              alt={c.string({
                key: 'app_tabs_monzo_me.marketing.trust_grid.bba.alt',
                message: 'British Bank Awards Best Banking App Winner 2023',
              })}
            />
          </li>
          <li>
            <img
              src={getCDNSrc(cass)}
              alt={c.string({
                key: 'app_tabs_monzo_me.marketing.trust_grid.cass.alt',
                message: 'Current Account Switch Guarantee',
              })}
            />
          </li>
          <li>
            <img
              src={getCDNSrc(fscs)}
              alt={c.string({
                key: 'app_tabs_monzo_me.marketing.trust_grid.fscs.alt',
                message: 'Financial Services Compensation Scheme Protected',
              })}
            />
          </li>
        </ul>
      </ShowForLocale>
    </div>
  )
}

export default SingleBlockBanner
